import React from 'react';
import MyIcon from '../my-icon';
import { removeHTMLScript } from '@laigu/utils/removeHTMLTag';

import style from './index.less';

const MessageMiniProgramCard = props => {
  const { data } = props;
  const { pic_url, title } = data;

  return (
    <div className={style['mini-program']}>
      <p>{title}</p>
      <div>
        <img alt='' src={removeHTMLScript(pic_url)} />
      </div>
      <div className='name'>
        <MyIcon type='ecoboost-iconfontxiaochengxu' />
        {'小程序'}
      </div>
    </div>
  );
};

export default MessageMiniProgramCard;
